module.exports = __webpack_public_path__ + "static/media/talent_connect.08f9c8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/talent_connect.png
// module id = 620
// module chunks = 0